import { AttributeReadModel } from "@Alternatives/Attributes/Domain/readmodels";
import { FormReadModel } from "@Alternatives/Forms/Domain/readmodels";
import Cookies from "js-cookie";

export class ViewSettingsEditorViewModel
{
    opened: boolean = false;

    alternativesLabel: string | null = null;    
    attributes: AttributeReadModel[] = [];
    forms: FormReadModel[] = [];

    viewSettings: ViewSettings;
    get formId(): number | null { return this.viewSettings.FormId; }
    get colorAttributeId(): number | null { return this.viewSettings.ColorAttributeId; }
    get columnAttributeId(): number | null { return this.viewSettings.ColumnAttributeId; }
    get viewDefId(): string | null { return this.viewSettings.ViewDefId; }
    get orderBy(): string | null { return this.viewSettings.OrderBy; }
    get orderType(): string | null { return this.viewSettings.OrderType; }

    constructor(projectId: number)
    {
        try
        {
            const cookie = Cookies.get(`ViewSettings_Alternatives_${projectId}`);

            if (cookie)
            {
                const storedViewSettings = JSON.parse(cookie) as Partial<ViewSettings>;

                if (storedViewSettings && typeof storedViewSettings === 'object')
                {
                    this.viewSettings = new ViewSettings(
                        projectId,
                        storedViewSettings.OrderBy ?? "name",
                        storedViewSettings.OrderType ?? "asc",
                        storedViewSettings.FormId ?? null,
                        storedViewSettings.ColorAttributeId ?? null,
                        storedViewSettings.ColumnAttributeId ?? null,
                        storedViewSettings.ViewDefId ?? null
                    );
                }
            }
        }
        catch (e)
        {
            console.error("Error loading view settings:", e);
        }

        if (this.viewSettings == null)
        {
            this.viewSettings = new ViewSettings(projectId);
        }
    }

    show(alternativesLabel: string, attributes: AttributeReadModel[], forms: FormReadModel[])
    {
        this.alternativesLabel = alternativesLabel;
        this.attributes = attributes;
        this.forms = forms;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.alternativesLabel = null;
        this.attributes = [];
        this.forms = [];
    }

    save()
    {
        const expiration = new Date();
        expiration.setDate(expiration.getDate() + 30);        

        Cookies.set(`ViewSettings_Alternatives_${this.viewSettings.ProjectId}`, JSON.stringify(this.viewSettings), { expires: expiration, path: "/" });
    }

    setViewDefId(viewDefId: string | null): boolean
    {
        if (this.viewDefId !== viewDefId)
        {
            this.viewSettings.ViewDefId = viewDefId;
            this.save();
            return true;
        }

        return false;
    }

    setOrderBy(by: string)
    {
        if (this.orderBy !== by)
        {
            this.viewSettings.OrderBy = by;
            this.viewSettings.OrderType = "asc";
        }
        else
        {
            if (this.viewSettings.OrderType === "asc")
            {
                this.viewSettings.OrderType = "desc";
            }
            else
            {
                this.viewSettings.OrderType = "asc";
            }
        }

        this.save();
    }
}

class ViewSettings
{
    ProjectId: number;
    OrderBy: string = "name";
    OrderType: string = "asc";
    FormId: number | null = null;
    ColorAttributeId: number | null = null;
    ColumnAttributeId: number | null = null;
    ViewDefId: string | null = null;

    constructor(projectId: number, orderBy = "name", orderType = "asc", formId: number | null = null,
        colorAttributeId: number | null = null, columnAttributeId: number | null = null,
        viewDefId: string | null = null)
    {
        this.ProjectId = projectId;
        this.OrderBy = orderBy;
        this.OrderType = orderType;
        this.FormId = formId;
        this.ColorAttributeId = colorAttributeId;
        this.ColumnAttributeId = columnAttributeId;
        this.ViewDefId = viewDefId;
    }
}